export enum SortOrderEnum {
    ascending = 'ASCENDING',
    descending = 'DESCENDING'
}
